module.exports = __webpack_public_path__ + "img/pvc_expomoda_shiny_0010_white_250x250.2e51f767.jpg";